import { LoyaltyClusterTypeService } from './../../../services/loyalty/loyalty-cluster-type.service';
import { ClusterType } from './../../../models/loyalty-cluster-type.model';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-loyalty-cluster-type',
  templateUrl: './loyalty-cluster-type.component.html',
  styleUrls: ['./loyalty-cluster-type.component.css']
})
export class LoyaltyClusterTypeComponent implements OnInit {

  columsTitles: any;
  totalRecords = 0;
  showModalDelete: boolean;
  translations: any;  

  listClusterType: Array<ClusterType>;


  constructor(
    private translate: TranslateService,
    private clusterTypeService: LoyaltyClusterTypeService,
    private router: Router
  ) { }

  ngOnInit() {

    this.listClusterType = [];    
    // load translation ONLY ONE TIME.    
    this.translate.get([
      'cluster_type.cluster_type_title',      
      'cluster_type.code',
      'cluster_type.description'
    ]).subscribe((translations) => {
      
      this.translations = translations;      

    });
   
    this.reloadList();
  }

  reloadList() {
    this.clusterTypeService.getAll().subscribe( (res) => {            
      this.listClusterType = res.data;      
    });
  }


  edit(param: ClusterType) {
    this.router.navigate(['/loyalty/cluster-type/form/' + param.id]);
  }

  addNew() {
    this.router.navigate(['/loyalty/cluster-type/form/']);
  }
  remove(clusterType) {
    this.showModalDelete = false;
    this.clusterTypeService.remove(clusterType.id).subscribe((res ) => {
      this.reloadList();
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-cluster-type/loyalty-cluster-type.component.ts